<div class="main-content">
    <div class="card">
        <p-table #dt [value]="listFeedback"
                 [rows]="row"
                 [first]="first"
                 [totalRecords]="totalRecords"
                 (onPage)="onLazyLoad($event)"
                 [paginator]="true"
                 [lazy]="true"
                 [rowHover]="true"
                 [showCurrentPageReport]="true" [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="lastName">{{ 'FEED_BACK.CLIENT_LABEL' | translate }}
                        <p-sortIcon field="lastName"></p-sortIcon>
                    </th>
                    <th>{{ 'FEED_BACK.PARTNER_LABEL' | translate }}</th>
                    <th>{{ 'FEED_BACK.COMMENT_LABEL' | translate }}</th>
                    <th>{{ 'FEED_BACK.RATING_LABEL' | translate }}</th>
                    <th>{{ 'FEED_BACK.DATE_LABEL' | translate }}</th>
                    <th>{{ 'FEED_BACK.STATUS_LABEL' | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-feedBack>
                <tr>
                    <td>{{feedBack.fullName}}</td>
                    <td>{{feedBack.partnerName}}</td>
                    <td>{{feedBack.comment}}</td>
                    <td>
                        <p-rating [ngModel]="feedBack.rating" readonly="true" stars="5" [cancel]="false"></p-rating>
                    </td>
                    <td>{{feedBack.creationDate | date: 'dd/MM/yyyy, HH:mm'}}</td>
                    <td (dblclick)="changeStatus(feedBack)" *ngIf="feedBack.statusFeedBack === 'VALIDATED'">
                        {{ 'FEED_BACK.VALIDATED_LABEL' | translate }}
                    </td>
                    <td (dblclick)="changeStatus(feedBack)"
                        *ngIf="feedBack.statusFeedBack === 'PENDING'">{{ 'FEED_BACK.PENDING_LABEL' | translate }}</td>
                    <td (dblclick)="changeStatus(feedBack)"
                        *ngIf="feedBack.statusFeedBack === 'DELETED'">{{ 'FEED_BACK.DELETED_LABEL' | translate }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
